import { Component, Input, OnInit } from '@angular/core';
import { SetQuoteTestimonial } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-testimonial',
  templateUrl: './sample-testimonial.component.html',
  styleUrls: ['./sample-testimonial.component.scss']
})
export class SampleTestimonialComponent implements OnInit {

  @Input() block: SetQuoteTestimonial = {} as SetQuoteTestimonial;
  @Input() column: string = '';
  public domainWebsite = environment.urlApi;
  public classItem: string = '';

  constructor(private helpersService: HelpersService) { }

  ngOnInit(): void {
    this.setItemColumn();
  }

  private setItemColumn() {
    switch (this.column) {
      case '2':
        this.classItem = 'testimonial-col2';
        break;
      case '1':
        this.classItem = 'testimonial-col1';
        break;
      default:
        this.classItem = 'testimonial-col34';
        break;
    }
  }

  public extractImageSrc(htmlString: string) {
    let imgSrc: any = "";
    if (this.helpersService.isBrowser) {
      let parser = new DOMParser();
      let htmlDoc = parser.parseFromString(htmlString, 'text/html');
      imgSrc = htmlDoc.querySelector('img')?.getAttribute('src');
    }
    return imgSrc;
  }

}
